
        <div class="scaffold-topbar-wrapper">
            <div
                class="scaffold-hamburger"
                [ngClass]="{ collapsed: collapsed }"
                (click)="toggle()"
            >
                <i class="fas fa-bars"></i>
            </div>
            <div class="scaffold-topbar">
                <sn-topbar [user]="user" (logout)="quit()"></sn-topbar>
            </div>
        </div>
        <div class="scaffold-application-wrapper">
            <div class="scaffold-sidebar" [ngClass]="{ collapsed: collapsed }">
                <sn-sidebar [apps]="apps"></sn-sidebar>
            </div>
            <div
                class="scaffold-subnav"
                [ngStyle]="{
                    display: subnavTmpl ? 'initial' : 'none'
                }"
            >
                <ng-template [ngTemplateOutlet]="subnavTmpl"></ng-template>
            </div>
            <div class="scaffold-content">
                <ng-template [ngTemplateOutlet]="contentTmpl"></ng-template>
            </div>
        </div>
    